




































































import {Vue, Component, Prop} from "vue-property-decorator";
import {LoraParser} from "@/types/core";
import TimestampAgo from "@/components/TimestampAgo.vue";
import EnterpriseId from "@/components/EnterpriseId.vue";
import tippy from 'tippy.js';

@Component({
  components: {
    TimestampAgo,
    EnterpriseId
  }
})
export default class LoraParserRow extends Vue {
  @Prop({ default: () => {},  type: Object}) loraParser!: LoraParser;

  @Prop({ default: 0,  type: Number}) index!: number;

  mounted() {
    tippy('[data-tippy-content]', {});
  }

  goToParserPage(loraParserId:string, dest:'edit'|'test'|'delete') {

    switch(dest) {
      case 'edit':
        return this.$router.push({name:'lora-parser-edit', params:{loraParserId: this.loraParser.loraParserId}});
      case 'test':
        return this.$router.push({name:'lora-parser-test', params:{loraParserId: this.loraParser.loraParserId}});
      case 'delete':
        return this.$router.push({name:'lora-parser-delete', params:{loraParserId: this.loraParser.loraParserId}});
    }
    
  }

}
